export default "__VITE_ASSET__D0sAgDdP__"